import Button from '@Components/Buttons/Button'
import SaveDraftButton from '@Components/Buttons/SaveDraftButton'
import ConfirmSubmission from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission'
import React, { useContext, useState } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import { observer } from 'mobx-react'
import WizardNavigationBarLayout from '@Components/WizardFlow/WizardNavigationBarLayout'
import './index.scss'
import WizardBackButton from '@Components/WizardFlow/WizardBackButton'
import WizardNextButton from '@Components/WizardFlow/WizardNextButton'
import ModalPortal from '@Components/Popups/ModalPortal'
import OverclaimWarningStep from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep'
import WizardSubmitButton from '@Components/WizardFlow/WizardSubmitButton'

const WizardCreateWorkNavigationBar = () => {
    const { workStore, createWorkSearchStore, rightsholderStore, wizardFlowStore, userStore } =
        useContext<RootStore>(StoresContext)

    const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false)

    const showSubmitButton = wizardFlowStore.currentIndex === wizardFlowStore.flowLength - 1

    const advanceToWizard = () => {
        wizardFlowStore.advanceIndex()
        wizardFlowStore.setCurrentSubIndex(0)
    }

    const createWork = async (isSavingDraftWork: boolean) => {
        const currentRhId = rightsholderStore.currentRightsholderId

        const draft = workStore.workDraftLocal
        if (!draft) {
            return
        }
        const creatingWork: WorkModel = {
            ...draft,
            id: !isSavingDraftWork ? draft.id : null,
            isComplete: !isSavingDraftWork,
        }
        await workStore.createWorkFromNavBar(creatingWork, currentRhId, !draft.isComplete, isSavingDraftWork)
    }

    const onSaveDraftButtonClicked = async () => {
        await createWork(true)
    }

    const onConfirmSubmitPressed = async () => {
        await createWork(false)
    }

    const onSubmitButtonPressed = () => {
        setSidebarIsOpen(true)
    }

    const onOverclaimWarningConfirm = () => {
        workStore.setOverclaimWarningOpen(false)
        showSubmitButton ? onSubmitButtonPressed() : wizardFlowStore.advanceIndex()
    }

    const LeftContent = (
        <>
            {wizardFlowStore.currentIndex === 0 && <div className="invisible-alignment-div" />}
            {wizardFlowStore.currentIndex > 0 && <WizardBackButton />}
        </>
    )

    const MiddleContent = (
        <>
            {wizardFlowStore.currentIndex > 0 && (
                <SaveDraftButton render disabled={userStore.isInternal} onClick={onSaveDraftButtonClicked} />
            )}
        </>
    )

    const RightContent = (
        <>
            {wizardFlowStore.currentIndex === 0 && !!createWorkSearchStore.createWorkSearchResults && (
                <Button mainColor type="primary" onClick={advanceToWizard}>
                    Create new work
                </Button>
            )}
            {wizardFlowStore.currentIndex > 0 && (
                <>
                    {showSubmitButton ? (
                        <WizardSubmitButton onSubmitButtonPressed={onSubmitButtonPressed} />
                    ) : (
                        <WizardNextButton disabled={!workStore.wizardStepIsValid} />
                    )}
                </>
            )}
        </>
    )

    return (
        <>
            <WizardNavigationBarLayout
                leftContent={LeftContent}
                middleContent={MiddleContent}
                rightContent={RightContent}
            />

            <ConfirmSubmission
                createWork={onConfirmSubmitPressed}
                isSideBarOpen={sidebarIsOpen}
                closeSidebar={() => setSidebarIsOpen(false)}
                isInternal={userStore.isInternal}
            />

            <ModalPortal isOpen={workStore.overclaimWarningOpen}>
                <OverclaimWarningStep
                    onClickConfirm={onOverclaimWarningConfirm}
                    onClickCancel={() => workStore.setOverclaimWarningOpen(false)}
                />
            </ModalPortal>
        </>
    )
}

export default observer(WizardCreateWorkNavigationBar)
